import api from "./api";

/* ======================================================
   STRICT FIELD WHITELIST
====================================================== */
const EVENT_FIELDS = new Set([
  "title",
  "date",
  "timeStart",
  "timeEnd",
  "locationName",
  "locationAddress",
  "whatsappPic",
  "description",
  "status",
  "ticketTiers",
  "image",
]);

/* ======================================================
   Convert payload → FormData (SAFE)
====================================================== */
function toFormData(payload = {}) {
  const form = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (!EVENT_FIELDS.has(key)) return;
    if (value === undefined || value === null) return;

    // Only ONE allowed file field
    if (key === "image") {
      if (value instanceof File) {
        form.append("image", value);
      }
      return;
    }

    // ticketTiers MUST be string
    if (key === "ticketTiers") {
      form.append("ticketTiers", String(value));
      return;
    }

    // primitives only
    form.append(key, String(value));
  });

  return form;
}

/* ======================================================
   ADMIN EVENT API
====================================================== */
export const AdminEventAPI = {
  /* =============================
   * LIST EVENTS
   * ============================= */
  list(params = {}) {
    return api.get("/api/admin/events", { params });
  },

  /* =============================
   * GET EVENT
   * ============================= */
  get(id) {
    if (!id) throw new Error("Event ID required");
    return api.get(`/api/admin/events/${id}`);
  },

  /* =============================
   * CREATE EVENT
   * ============================= */
  create(payload) {
    return api.post(
      "/api/admin/events",
      toFormData(payload)
      // ❗ DO NOT SET HEADERS
    );
  },

  /* =============================
   * UPDATE EVENT
   * ============================= */
  update(id, payload) {
    if (!id) throw new Error("Event ID required");

    return api.put(
      `/api/admin/events/${id}`,
      toFormData(payload)
      // ❗ DO NOT SET HEADERS
    );
  },

  /* =============================
   * DELETE (ARCHIVE)
   * ============================= */
  remove(id) {
    if (!id) throw new Error("Event ID required");
    return api.delete(`/api/admin/events/${id}`);
  },

  /* =============================
   * DASHBOARD STATS
   * ============================= */
  stats() {
    return api.get("/api/admin/events/stats");
  },
};

/* ======================================================
   UPLOAD CONTENT IMAGE (WYSIWYG inline)
====================================================== */
export async function uploadContentImage(file) {
  const fd = new FormData();
  fd.append("image", file);
  const res = await api.post("/api/admin/events/upload-image", fd);
  return res.data.url;
}
